module.exports = "<div class=\"col-xs-12 text-center log-status-message\"></div>\n<div id=\"log\"><table></table></div>\n"